// src/hooks/useRetornoAsesor.js
import { useUsers } from "../metodos/userContext";
import { useConfiguracion } from "../metodos/ConfiguracionContext";

//nombre e info de asesor - nombre - empresa
export const useRetornoAsesor = () => {
    const { configuracion, loadingConfiguracion } = useConfiguracion();
    const { usuario, loadingUsuario, errorUsuario } = useUsers();
    
    const retornoAsesor = () => {
        if (!usuario || !configuracion) return '';
        return `${usuario.nombrewhatsapp} - ${configuracion.nombreEmpresa}`;
    };

    const referidoPor = (nombre_empresa) =>{
        let referido = "";

        if(configuracion.nombreEmpresa == nombre_empresa){
            referido = "";
        }else{
            referido = configuracion.nombreEmpresa;
        }

        return referido;

    }

    //seleccionar identificador de codigo
    const retornarIdentificadorCodigo = (solicitud) =>{
        const servicio = solicitud.Servicio;

        if(servicio == "PARCIAL"){
            return 'P';
        }
        if(servicio == "QUIZ"){
            return 'Q';
        }
        if(servicio == "TALLER"){
            return 'T';
        }
        if(servicio == "CLASES PERSONALIZADAS"){
            return 'A';
        }
        if(servicio == "TESIS"){
            return 'TES';
        }

        return 'NO-PROGRAMADO';

    }
    
    const loading = loadingConfiguracion || loadingUsuario;
    const error = errorUsuario;
    
    return {
        retornoAsesor,
        referidoPor,
        nombreAsesor: retornoAsesor(),
        loading,
        error,
        usuario,
        configuracion,
        retornarIdentificadorCodigo,
    };
};

//nombre de empresa real
// Quita el "use" y expórtala como una función normal
export const obtenerNombreEmpresaReal = (nombreEmpresa) => {
  if (!nombreEmpresa) return "";
  
  if (nombreEmpresa === 'DUFY_ASESORIAS') {
    return nombreEmpresa.replace(/_/g, ' ');
  }
  return nombreEmpresa;
};

//ADMIN
export const useisUserAdmin = (usuario) =>{
    const isAdmin = (usuario?.rol === "ADMIN" || usuario?.rol === "COLABORADOR") ? true : false;
    return isAdmin;
}
//TUTOR
export const useisUserTutor = (usuario) =>{
    const isAdmin = (usuario?.rol === "TUTOR") ? true : false;
    return isAdmin;
}
//CLIENTE
export const useisUserCliente = (usuario, publicView = false) => {
    // Es cliente si tiene el rol O si estamos en una vista pública
    const isCliente = !!(usuario?.rol === "CLIENTE" || publicView === true);
    console.log("is cliente",isCliente);
    return isCliente;
}

export const rolUsuario = (usuario) =>{
    const rol = usuario.rol;
    return rol;
}

//ADMIN Y DUFY ASESORIAS
export const useisUserAdminAndDufy = (usuario,nombreEmpresa) => {
    const isDufy = nombreEmpresa === "DUFY ASESORIAS";
    const isAdmin = (usuario?.rol === "ADMIN" || usuario?.rol === "COLABORADOR") ? true : false;
    return isAdmin && isDufy;
}

//solicitudes
//la puede ver cualquier tutor mientras este disponible
//la solicitud solo el cliente puede ver sus solicitudes, no puede ver otras solcitudes
//validacion desde server